'use strict';

var cov_100fopm6yi = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/cart/lib/constants.js',
      hash = 'd2226b11e40a646e8d4fe7408d2660c859291a30',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/cart/lib/constants.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 24
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CartActionTypes = (cov_100fopm6yi.s[0]++, {
  CART_BEFORE_LOAD: 'CART_BEFORE_LOAD',
  CART_LOAD_SUCCESS: 'CART_LOAD_SUCCESS',
  CART_LOAD_ERROR: 'CART_LOAD_ERROR',
  CART_INITIAL_STATE: 'CART_INITIAL_STATE'
});
exports.default = CartActionTypes;